<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "CHANGE_PASSWORD.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card>
    <mat-card-content>
        <button
            [id]="'button_profile-change-password_EditarSalvar'"
            mat-mini-fab
            color="primary"
            (click)="toggleEdition()"
            class="edition-button"
            [disabled]="editMode && (formGroup?.invalid || !this._validPassword)"
        >
            <mat-icon aria-label="label">{{ editMode ? "save" : "create" }}</mat-icon>
        </button>

        <div class="form-container">
            <form [formGroup]="formGroup">
                <mat-form-field>
                    <mat-label>{{ "CHANGE_PASSWORD.INPUTS.PASSWORD" | translate }}</mat-label>
                    <input
                        [id]="'input_profile-change-password_Password'"
                        matInput
                        #senhaAtual
                        maxlength="20"
                        formControlName="senhaAtual"
                        required
                        type="password"
                        #oldPassword
                    />
                    <mat-icon
                        matSuffix
                        color="secondary"
                        (click)="oldPassword.type = oldPassword.type == 'text' ? 'password' : 'text'"
                    >
                        {{ oldPassword.type == "text" ? "visibility_off" : "visibility" }}
                    </mat-icon>
                    <mat-hint align="end"> {{ senhaAtual.value.length }} / 20 </mat-hint>
                </mat-form-field>

                <app-password-validator
                    *ngIf="editMode"
                    [passwordRegex]="getPasswordRegex()"
                    [passwordCustomRules]="getPasswordCustomRules()"
                    (validValue)="validPassword($event)"
                    (password)="password($event)"
                ></app-password-validator>
            </form>
        </div>
    </mat-card-content>
</mat-card>
